import styled from 'styled-components';

export const Container = styled.div`
  .management-card-link {
    cursor: pointer;
    height: 100% !important;

    @media only screen and (max-width: 768px) {
      height: auto !important;
    }

    &.active {
      background: ${(props) => props.theme.$dark_medium};
      color: ${(props) => props.theme.$white};
    }

    &:hover {
      background: ${(props) => props.theme.$dark_light};
      color: ${(props) => props.theme.$white};
    }
  }

  .calendar-card {
    font-size: 8em;
  }
`;
